import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("small", { class: "text-warning ml-2" }, "No hay cuentas!", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-warning ml-2"
}
const _hoisted_4 = {
  key: 1,
  class: "text-warning ml-2"
}
const _hoisted_5 = { class: "d-flex pt-2 pb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Cancelar", -1)

import { Form } from "vee-validate";
import { onMounted, ref } from "vue";
import { coreApi } from "@/conection";
import Modal from "@/components/Modal.vue";
import { IAgent } from "vue-advanced-chat";
import { AuthModule } from "@/store/modules/Auth";
import Select from "@/components/Inputs/Select.vue";
import { TicketModule } from "@/store/modules/Ticket";
import { schemaShare } from "@/store/schemas/ticket.shema";
import { NotificationPayload } from "@/store/modules/Notification";
import { ModalSidebarState as ModalState } from "@/types/components";
import { env } from "@/config";
import { IAccount } from "@/store/modules/Account";
// props

export default /*#__PURE__*/_defineComponent({
  props: {
    open: { type: Boolean },
    type: null
  },
  emits: ["changeModal"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "changeModal", t: ModalState): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { open: boolean; type: ModalState["type"] }


// emits


// State data
const agents = ref<IAgent[]>([]);
const model = ref<string>();
const loading = ref(false);
const agentOptions = ref<
	Array<{ value: IAgent; label: string; disabled?: boolean }>
>([]);
const accountOptions = ref<
	Array<{ value: IAccount; label: string; disabled?: boolean }>
>([]);

// Methods

// Functions
function getNotification(a: string): NotificationPayload {
	if (!props.type) throw "error";
	return {
		share: {
			button: true,
			agent: a.split(","),
			title: "Nuevo ticket compartido",
			icon: "fas fa-share",
			description: `El agente ${AuthModule.data.user?.name} le ha compartido el ticket de: ${TicketModule.currentRoom?.users[0].username}`,
			action: `share/${TicketModule.currentRoomID}`,
		},
		reasign: {
			button: false,
			agent: a.split(","),
			title: "Ticket reasignado",
			icon: AuthModule.data.user?.picture,
			type: "info",
			description: `El agente ${AuthModule.data.user?.name} le ha reasignado el ticket de: ${TicketModule.currentRoom?.users[0].username}`,
			action: `read/rasgnd/${TicketModule.currentRoomID}`,
		},
		ticket: {}, client: {}
	}[props.type] as NotificationPayload;
}

async function accountChange(accountId: string) {
	if(agents.value.length >= 1) {
		const account = accountOptions.value.find(ac => ac.value._id === accountId)?.value;
		agentOptions.value = agents.value.reduce((acc, curr) => {
			if(account?.agents.includes(curr._id))
				acc.push({
					value: curr,
					label: curr.name.toLowerCase(),
				})
			return acc;
		}, [] as Array<{ value: IAgent; label: string; disabled?: boolean }>)
	}
}

async function onSubmit(e: { agent: string, account: string }) {
	const notification = getNotification(e.agent);
	loading.value = true;
	if (props.type === "reasign")
		await coreApi.post("api/ticket/reasign", {
			onlyConnectedAgents: env.onlyConnectedAgents,
			currentAgent: AuthModule.id,
			ticketId: TicketModule.currentRoomID,
			newAgent: e.agent,
			agents: TicketModule.currentTicket?.agent.map(a => a._id),
		});
	const response = await coreApi.post("/api/notification/create", {
		onlyConnectedAgents: env.onlyConnectedAgents,
		notification,
	});
	loading.value = false;
	if (response.data.success) emits("changeModal", { show: false });
}
onMounted(async () => {
	const accountResponse = await coreApi.post("/api/account/list");
	const agentResponse = env.onlyConnectedAgents ? await coreApi.get<{ agents: IAgent[] }>("/api/agent/all/connected") : await coreApi.get<{ agents: IAgent[] }>("/api/agent/all");
	agents.value = agentResponse.data.agents.filter(
		a => a._id !== AuthModule.data.user?.id
	);

	if(accountResponse.data.accounts.length)
		accountOptions.value = accountResponse.data.accounts.map(ac => ({
			value: ac,
			label: ac.name.toLowerCase(),
		}))
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(Modal, {
    show: props.open,
    "modal-classes": "modal-secondary",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emits('changeModal', { show: false }))),
    "body-classes": "py-0",
    style: {"animation-duration":"0.3s"},
    "modal-content-classes": "bg-gradient-secondary"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, "Ticket de " + _toDisplayString(_unref(TicketModule).currentRoom?.users[0].username), 1)
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_unref(Form), {
        "validation-schema": _unref(schemaShare)(),
        onSubmit: _cache[1] || (_cache[1] = (e) => onSubmit(e))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Select, {
              name: "account",
              label: "Seleccione una cuenta",
              placeholder: "Seleccione una cuenta",
              "label-classes": "text-muted h5 font-weight-normal",
              "addon-left-icon": "fas fa-suitcase",
              value: model.value,
              "select-options": {
						options: accountOptions.value,
						noDataText: 'Sin cuentas',
						valueKey: '_id',
						multiple: false,
					},
              alternative: ""
            }, _createSlots({
              default: _withCtx((slotProp) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProp.options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value?._id,
                    label: item.value?.name,
                    value: item.value?._id,
                    onClick: ($event: any) => (accountChange(item.value?._id ?? ''))
                  }, null, 8, ["label", "value", "onClick"]))
                }), 128))
              ]),
              _: 2
            }, [
              (accountOptions.value.length < 1)
                ? {
                    name: "infoBlock",
                    fn: _withCtx(() => [
                      _hoisted_2
                    ])
                  }
                : undefined
            ]), 1032, ["value", "select-options"]),
            _createVNode(Select, {
              name: "agent",
              label: 
						__props.type === 'share'
							? 'Seleccione a los agentes que compartirá el ticket'
							: 'Seleccione al agente al que reasignará el ticket'
					,
              placeholder: "Seleccione un agente",
              "label-classes": "text-muted h5 font-weight-normal",
              "addon-left-icon": "fas fa-user-plus",
              value: model.value,
              "select-options": {
						options: agentOptions.value,
						noDataText: 'Sin agentes',
						valueKey: '_id',
						multiple: __props.type === 'share',
					},
              alternative: ""
            }, _createSlots({
              default: _withCtx((slotProp) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProp.options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value?._id,
                    label: item.value?.name,
                    value: item.value?._id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 2
            }, [
              (agentOptions.value.length < 1)
                ? {
                    name: "infoBlock",
                    fn: _withCtx(() => [
                      (agents.value.length)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_3, "Debes seleccionar una cuenta!"))
                        : (_openBlock(), _createElementBlock("small", _hoisted_4, "No hay agentes conectados!"))
                    ])
                  }
                : undefined
            ]), 1032, ["label", "value", "select-options"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_base_button, {
                type: "link",
                onClick: _cache[0] || (_cache[0] = () => emits('changeModal', { show: false }))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_base_button, {
                type: "primary",
                loading: loading.value,
                "native-type": "submit",
                class: "ml-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.type === "share" ? "Compartir" : "Reasignar"), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})